
import MonthPicker from '../components/month-picker.vue';
import SortPicker from '../components/sort-picker.vue';
import AttSchedule from '../employee/att-schedule.vue';
import ReviewBox from '../employee/review-box.vue';
import RestSchedule from '../employee/rest-schedule.vue';
export default {
  name: 'attTable',
  components: {
    SortPicker,
    MonthPicker,
    AttSchedule,
    ReviewBox,
    RestSchedule
  },
  created() {
    let t = this;

    if (localStorage['att_table_scale']) {
      t.tableScale = Number(localStorage['att_table_scale']);
    }

    t.today = Date.today();
    t.month = t.today.getMonth() + 1;
    t.year = t.today.getFullYear();

    t.todayStr = t.today.format('yyyy-MM-dd');

    let items = [];

    if (localStorage['selected_months']) {
      items = localStorage['selected_months'].split(',');
    }

    if (items.length == 0) {
      for (let i = 0; i < 3; i++) {
        items.push(t.year + '/' + t.pad2(t.month + i - 1));
      }
    }

    t.list.selectedMonths = items;

    t.prepare().then(t.loadData);

    t.selectedDate = new Date();
  },
  activated() {
    let t = this;
  },
  methods: {

    saveTableScale() {
      localStorage['att_table_scale'] = this.tableScale;
    },

    removeUnit(item) {
      let t = this;

      A.safety(t.t('表示を消しても宜しいですか?')).then(res => {
        if (res.isConfirmed) {
          t.list.selectedUnit.remove(item);
          if (t.list.selectedUnit.length > 0) {
            let arr = [];
            t.list.selectedUnit.forEach(item => {
              arr.push(item.id);
            });
            localStorage["selected_unit_ids"] = arr.join(",");
          }

        }
      });

    },

    removeMonth(month) {
      let t = this;

      A.safety(t.t('表示を消しても宜しいですか?')).then(res => {
        if (res.isConfirmed) {
          t.list.selectedMonths.remove(month);
          t.loadData();
        }
      });

    },

    addDate() {
      let t = this;
      if (t.selectedDate) {
        let text = t.selectedDate.format('yyyy/MM');

        let exist = false;
        t.list.selectedMonths.forEach(date => {
          if (text == date) {
            exist = true;
          }
        })
        if (exist) {
          A.err('この月はすでに存在します。');
        }
        else {
          t.list.selectedMonths.push(text);
          t.list.selectedMonths = t.list.selectedMonths.sort();
          localStorage['selected_months'] = t.list.selectedMonths.join(',');
          t.loadData();
        }
      }

      t.showMonthsPopover = false;

    },

    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },

    prepare() {

      let t = this;

      return new Promise((resolve, reject) => {

        axios.get('unit').then(res => {
          if (res.data.status == 1) {

            let arr = res.data.options.items;

            arr.forEach(item => {
              item.employees = [
              ];
            });

            let arr2 = [{ 'id': 0, 'name': '無所属', 'employees': [] }];

            t.list.unit = arr2.append(arr);;

            t.dict.unit = listToDict(t.list.unit);

            axios.get('employee?role=4&_with=config').then(res => {

              if (res.data.status == 1) {

                let arr = res.data.options.items;

                t.list.employee = [];

                arr.forEach(e => {
                  e.fullname = e.name;
                  e.status_text = '';
                  e.status_color = '';

                  t.list.employee.push(e);

                  if (e.config) {
                    let unit = t.dict.unit[e.config.unit_id];
                    if (unit) {
                      unit.employees.push(e);
                    }
                    else {
                      this.list.unit[0].employees.push(e);
                    }
                  }
                  else {
                    this.list.unit[0].employees.push(e);
                  }

                });

                if (t.list.unit[0].employees.length == 0) {
                  t.list.unit.remove(t.list.unit[0]);
                }

                t.list.unit2 = [];

                t.list.unit.forEach((unit, i) => {
                  if (i < 1 || unit.employees.length > 0) {
                    t.list.unit2.push(unit);
                  }
                });

                if (localStorage['selected_unit_ids']) {
                  let ids = localStorage['selected_unit_ids'].split(',');
                  t.list.unit2.forEach(unit => {
                    if (ids.indexOf(unit.id.toString()) > -1)
                      t.list.selectedUnit.push(unit);
                  });
                }

                t.dict.employee = listToDict(t.list.employee);

                t.inited = true;

                resolve();
              }
            });
          }
        });

      });


    },

    loadData() {

      let t = this;

      let params = {
        'start_date': t.list.selectedMonths[0],
        'end_date': t.list.selectedMonths[t.list.selectedMonths.length - 1],
      };

      t.list.month = [];

      t.list.selectedMonths.forEach(month => {

        let date = new Date(month + '/01');

        let item = {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          text: month,
          date: date,
          days: []
        };

        t.reviewSchedule[month] = {};
        t.unitToggle[month] = {};

        t.list.unit2.forEach(unit => {
          t.unitToggle[month][unit.id] = 1;
        });

        const daysInMonth = new Date(item.year, item.month, 0).getDate();

        for (let day = 1; day <= daysInMonth; day++) {
          const formattedDate = `${item.year}-${String(item.month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          let dayObj = {
            'date': formattedDate,
            'day_index': (new Date(formattedDate)).getDay()
          };
          t.dateCell[formattedDate] = {};

          item.days.push(dayObj);
        }

        t.list.month.push(item);
      });

      localStorage['selected_months'] = t.list.selectedMonths.join(',');

      for (const date in t.dateCell) {
        t.list.employee.forEach(e => {
          let staticRest = false;
          let hasConfig = false;
          if (e.config) {
            hasConfig = true;
            let days = e.config.static_rest_day.split(',');
            staticRest = days.indexOf((new Date(date)).getDay().toString()) > -1;
          }
          let entryDate = new Date(e.entry_date);
          let curDate = new Date(date);

          t.dateCell[date][e.id] = {
            hasConfig: hasConfig,
            hasReview: false,
            beforeEntry: curDate < entryDate,
            hasScheduleReview: false,
            static_rest: staticRest,
            leave: null,
            fieldWork: null,
            shift: null,
            sup: null,
            start_time: '',
            end_time: '',
            rest_am: false,
            rest_pm: false,
            work: 0,
            rest_to_work: 0,
            rest_date: '',
            dynamic_rest: false,
            work_date: '',
            clockIns: [],
            today_status: '',
          };
        });
      }

      axios.get('clockIn/attTable', { params: params }).then(res => {
        if (res.data.status == 1) {
          res.data.options.sup.forEach(item => {

            if (!t.dateCell[item.date]) {
              return;
            }

            if (t.dateCell[item.date][item.employee_id]) {
              t.dateCell[item.date][item.employee_id].sup = item;
              if (item.status == 0)
                t.dateCell[item.date][item.employee_id].hasReview = true;
            }
          });
          res.data.options.field_work.forEach(item => {

            if (!t.dateCell[item.date]) {
              return;
            }

            if (t.dateCell[item.date][item.employee_id]) {
              t.dateCell[item.date][item.employee_id].fieldWork = item;
              if (item.status == 0)
                t.dateCell[item.date][item.employee_id].hasReview = true;
            }
          });
          res.data.options.schedule.forEach(item => {
            let schedule = JSON.parse(item.data);
            schedule.forEach(dateItem => {

              if (!t.dateCell[dateItem.date]) {
                return;
              }

              let cellItem = t.dateCell[dateItem.date][item.employee_id];

              if (cellItem) {
                cellItem.start_time = dateItem.start_time;
                cellItem.end_time = dateItem.end_time;
                cellItem.work = dateItem.work;
                cellItem.rest_to_work = dateItem.rest_to_work;
                cellItem.rest_date = dateItem.rest_date;

                cellItem.rest_am = dateItem.rest_am;
                cellItem.rest_pm = dateItem.rest_pm;
                cellItem.static_rest = false;

                if (cellItem.rest_to_work == 1) {
                  let cellItem2 = t.dateCell[dateItem.rest_date][item.employee_id];

                  if (cellItem2) {
                    cellItem2.dynamic_rest = true;
                    cellItem2.work_date = dateItem.date;
                  }
                }
              }
            });
            let monthText = item.year + '/' + t.pad2(item.month);
            t.reviewSchedule[monthText][item.employee_id] = item;
          });
          res.data.options.shift.forEach(item => {

            if (!t.dateCell[item.date]) {
              return;
            }

            if (t.dateCell[item.date][item.employee_id]) {
              let dateItem = t.dateCell[item.date][item.employee_id];
              let restDateItem = t.dateCell[item.rest_date][item.employee_id];
              dateItem.shift = item;
              if (item.status == 0)
                dateItem.hasReview = true;
              dateItem.static_rest = 0;
              dateItem.rest_to_work = 1;
              dateItem.rest_date = item.rest_date;
              if (restDateItem.start_time) {
                dateItem.start_time = restDateItem.start_time;
                dateItem.end_time = restDateItem.end_time;
              }
              restDateItem.dynamic_rest = true;
              restDateItem.work_date = item.date;
            }
          });
          res.data.options.leave.forEach(item => {

            if (!t.dateCell[item.date]) {
              return;
            }

            if (t.dateCell[item.date][item.employee_id]) {
              item.leave_data = JSON.parse(item.leave_data);
              let dateItem = t.dateCell[item.date][item.employee_id];
              if (item.status == 0)
                dateItem.hasReview = true;
              dateItem.leaveReq = item;
              item.leave_data.forEach(leaveData => {
                if (t.dateCell[leaveData.date]) {
                  let leaveDateItem = t.dateCell[leaveData.date][item.employee_id];
                  if (leaveDateItem) {
                    leaveDateItem.leave = leaveData;
                    leaveDateItem.leave.type = item.type;
                    leaveDateItem.leave.timespan = item.timespan;
                  }
                }
              });
            }
          });
          res.data.options.clock_in.forEach(item => {
            if (!t.dateCell[item.date]) {
              return;
            }

            if (t.dateCell[item.date][item.employee_id]) {
              t.dateCell[item.date][item.employee_id].clockIns.push(item);
            }
          });
          
          t.list.employee.forEach(e => {

            if(!t.dateCell[t.todayStr])
              return;
            let cellItem = t.dateCell[t.todayStr][e.id];

            if (cellItem.static_rest || cellItem.dynamic_rest) {
              e.status_text = '休み';
              e.status_color = '_grey';
            }

            if (cellItem.rest_am && cellItem.rest_pm) {
              e.status_text = '有休';
              e.status_color = '_grey';
            }
            else if (cellItem.rest_am) {
              e.status_text = '有休AM';
              e.status_color = '_grey';
            }
            else if (cellItem.rest_pm) {
              e.status_text = '有休PM';
              e.status_color = '_grey';
            }

            if (cellItem.leave && cellItem.leave.type == 1) {
              if (cellItem.leave.rest_am == 1 && cellItem.leave.rest_pm == 1)
                e.status_text = '有休';
              else if (cellItem.leave.rest_am == 1)
                e.status_text = '有休AM';
              else if (cellItem.leave.rest_pm == 1)
                e.status_text = '有休PM';
              e.status_color = '_grey';
            }
            else if (cellItem.leave && cellItem.leave.type == 2) {
              if (cellItem.leave.rest_am == 1 && cellItem.leave.rest_pm == 1)
                e.status_text = '無給休暇';
              else if (cellItem.leave.rest_am == 1)
                e.status_text = '無給AM';
              else if (cellItem.leave.rest_pm == 1)
                e.status_text = '無給PM';

              e.status_color = '_orange';
            }

            if (cellItem.clockIns.length > 0) {

              let toRemove = [];

              let dict = {};

              cellItem.clockIns.forEach(clockData => {
                if (!dict[clockData.type]) {
                  dict[clockData.type] = clockData;
                }
                else {
                  if (clockData.sup_id && !dict[clockData.type].sup_id) {
                    toRemove.push(dict[clockData.type]);
                  }
                  else if (!clockData.sup_id && dict[clockData.type].sup_id) {
                    toRemove.push(clockData);
                  }
                  else if (clockData.sup_id && dict[clockData.type].sup_id) {

                    if (clockData.sup_id > dict[clockData.type].sup_id) {
                      toRemove.push(dict[clockData.type]);
                    }
                    else {
                      toRemove.push(clockData);
                    }
                  }
                }
              });

              toRemove.forEach(_item => {
                cellItem.clockIns.remove(_item);
              });

              if (dict[2]) {
                e.status_text = '帰宅';
                e.status_color = '_grey';
              }
              else if (dict[1]) {
                e.status_text = '出勤中';
                e.status_color = '_blue';
                if (cellItem.work == 2) {
                  e.status_text = 'OL' + e.status_text;
                }
              }

            }

          });
          for (const date in t.dateCell) {

            let d = t.dateCell[date];

            for (const eid in d) {

              let cellItem = d[eid];

              if (cellItem.clockIns.length > 0) {

                let toRemove = [];

                let dict = {};

                cellItem.clockIns.forEach(clockData => {
                  if (!dict[clockData.type]) {
                    dict[clockData.type] = clockData;
                  }
                  else {
                    if (clockData.sup_id && !dict[clockData.type].sup_id) {
                      toRemove.push(dict[clockData.type]);
                    }
                    else if (!clockData.sup_id && dict[clockData.type].sup_id) {
                      toRemove.push(clockData);
                    }
                    else if (clockData.sup_id && dict[clockData.type].sup_id) {

                      if (clockData.sup_id > dict[clockData.type].sup_id) {
                        toRemove.push(dict[clockData.type]);
                      }
                      else {
                        toRemove.push(clockData);
                      }
                    }
                  }
                });

                toRemove.forEach(_item => {
                  cellItem.clockIns.remove(_item);
                });

                cellItem.clockIns.forEach(clockData => {
                  if (clockData.type == 1 && clockData.time) {
                    cellItem.start_time = clockData.time.substr(0, 5);
                  }
                  else if (clockData.type == 2 && clockData.time) {
                    cellItem.end_time = clockData.time.substr(0, 5);
                  }
                });
              }
            }
          }
          t.$forceUpdate();
          // t.initScrollSync();
        }
      });

    },

    initScrollSync() {
      setTimeout(function () {
        const div1 = document.getElementById('leftScroll');
        const div2 = document.getElementById('rightScroll');

        if (div1.getAttribute('data-inited') == 1) {
          return;
        }

        div1.setAttribute('data-inited', 1);
        div2.setAttribute('data-inited', 1);

        div1.addEventListener('scroll', () => {
          div2.scrollTop = div1.scrollTop;
        });

        div2.addEventListener('scroll', () => {
          div1.scrollTop = div2.scrollTop;
        });
      }, 200);
    },

    refreshUnitSelection() {
      let t = this;
      let arr = [];

      let res = t.$refs.unitPicker.selection;

      if (res.length > 0) {

        res.forEach(item => {
          arr.push(item.id);
        });
        localStorage["selected_unit_ids"] = arr.join(",");
      }

      t.list.selectedUnit.clear();
      t.list.selectedUnit.append(res);
      t.loadData();
      t.$forceUpdate();
    },

    onSelectedMonthsChanged() {
      t.loadData();
    },

    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },

    notifyEmployee(review_id) {

      let t = this;

      A.toast('相談の通知を送信しました。');

      axios.post('attScheduleReview/notifyEmployee', { review_id }).then(res => {
        if (res.data.status == 1) {

        }
      });

    },

    urgeEmployee(year, month, employee_id) {

      let t = this;

      A.toast('催促の通知を送信しました。');

      let p = {
        year, month, employee_id
      };

      axios.post('attScheduleReview/urgeEmployee', p).then(res => {
        if (res.data.status == 1) {

        }
      });

    },

    confirmSchedule(review) {

      let t = this;
      let f = {
        'month': t.month
      };

      axios.post('attScheduleReview/confirm/' + review.id, f).then(res => {
        if (res.data.status == 1) {
          A.show('保存済み', '', 'success');
        }
      });

    },

    editSchedule(employee, scheduleReview, monthItem) {

      let t = this;

      t.employee = employee;
      t.scheduleReview = scheduleReview;
      t.monthDate = monthItem.date;
      t.showScheduleEditor = true;
    },

    editLeaveSchedule(employee, monthItem) {

      let t = this;

      t.employee = employee;
      t.monthDate = monthItem.date;
      t.showLeaveScheduleEditor = true;
    },

    attScheduleConfirmed(data) {
      let t = this;
      if (t.scheduleReview) {
        t.scheduleReview.status = 2;
        t.scheduleReview.data = data;
      }
      let schedule = JSON.parse(data);
      schedule.forEach(dateItem => {
        let cellItem = t.dateCell[dateItem.date][t.employee.id];
        cellItem.start_time = dateItem.start_time;
        cellItem.end_time = dateItem.end_time;
        cellItem.work = dateItem.work;
        cellItem.rest_to_work = dateItem.rest_to_work;
        cellItem.rest_date = dateItem.rest_date;
        cellItem.rest_am = dateItem.rest_am;
        cellItem.rest_pm = dateItem.rest_pm;

        cellItem.static_rest = false;

        if (cellItem.rest_to_work == 1) {
          let cellItem2 = t.dateCell[dateItem.rest_date][t.employee.id];

          if (cellItem2) {
            cellItem2.dynamic_rest = true;
            cellItem2.work_date = dateItem.date;
          }
        }
      });
      t.employee = null;
      t.scheduleReview = null;
      t.showScheduleEditor = false;
      t.$forceUpdate();
    },

    openReview(cellItem, employee) {
      let t = this;

      t.reviewItem = null;
      t.cellItem = cellItem;
      t.reviewType = 0;

      if (cellItem.fieldWork && cellItem.fieldWork.status == 0) {
        t.reviewItem = cellItem.fieldWork;
        t.reviewType = 2;
      }
      else if (cellItem.sup && cellItem.sup.status == 0) {
        t.reviewItem = cellItem.sup;
        t.reviewType = 1;
      }
      else if (cellItem.shift && cellItem.shift.status == 0) {
        t.reviewItem = cellItem.shift;
        t.reviewType = 3;
      }
      else if (cellItem.leaveReq && cellItem.leaveReq.status == 0) {
        t.reviewItem = cellItem.leaveReq;
        t.reviewType = 5;
      }
      if (t.reviewItem) {
        t.showReviewPopup = true;
        t.reviewItem.employee = employee;
      }
      else {
        t.cellItem = null;
      }
    },

    reviewConfirmd() {
      if (this.cellItem) {
        this.cellItem.hasReview = false;
        this.reviewItem.status = 1;
      }
    },

    reviewRejected() {
      if (this.cellItem) {
        this.cellItem.hasReview = false;
        this.reviewItem.status = 2;
      }
    },

    printA3() {
      if (window._printStyleTag) window._printStyleTag.remove();
      // transform: scale(0.9) !important;
      let style = "@media print { @page {  size: A3 landscape !important; } .room-rows { zoom:0.9 !important;   transform-origin: left top; } }";

      let s = document.createElement("style");
      s.innerHTML = style;
      document.body.appendChild(s);
      window._printStyleTag = s;
      window.print();
    },

    printA4() {
      if (window._printStyleTag) window._printStyleTag.remove();
      let style = "@media print { @page {  size: A4 landscape !important; } .room-rows { zoom:0.62 !important;  transform-origin: left top; } }";

      let s = document.createElement("style");
      s.innerHTML = style;
      document.body.appendChild(s);
      window._printStyleTag = s;
      window.print();
    },


  },
  data() {
    return {

      tableScale: 1,

      showReviewPopup: false,
      reviewType: 0,
      reviewItem: null,
      cellItem: null,

      selectedDate: null,

      monthDate: null,
      showScheduleEditor: false,
      showLeaveScheduleEditor: false,
      scheduleReview: null,
      employee: null,

      today: null,
      todayStr: '',
      year: 2025,
      month: 5,
      showMonthsPopover: false,
      showUnitsSelector: false,
      inited: false,
      minDate: new Date('2025-04-01'),
      stats: {
      },
      list: {
        unit: [],
        unit2: [],
        employee: [],
        selectedUnit: [],
        month: []
      },
      dict: {
        unit: {},
        employee: {},
        eStatus: {},
      },
      unitToggle: {},
      dateCell: {},
      reviewSchedule: {},
    };
  },
  computed: {
  },
};
